import React from 'react';
import { Table } from 'rsuite';
import PropTypes from 'prop-types';
import StoplightIndicator from '../../../StoplightIndicator';

const { Cell } = Table;

const FoodStopLightCell = ({ rowData, dataKey, ...props }) => (
  <Cell {...props}>
    <StoplightIndicator value={rowData[dataKey]} />
  </Cell>
);

FoodStopLightCell.propTypes = {
  dataKey: PropTypes.string.isRequired,
  rowData: PropTypes.shape({ status: PropTypes.number })
};

FoodStopLightCell.defaultProps = {
  rowData: null
};

export default FoodStopLightCell;
